import { controlsContainerStyles } from "@dana/Overrides/Widgets/ProductList/ProductListControlsContainer";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

controlsContainerStyles.viewSelectGridItem = mergeToNew(controlsContainerStyles.viewSelectGridItem, {
    css: css`
        > [class*="Wrapper"] {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          column-gap: 16px;
        }
    `,
});